import { useState, useEffect } from 'react';

export default function SeasonAnnouncement() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date('2025-05-03T00:00:00').getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative py-20 bg-gradient-to-br from-gray-900 via-red-900 to-black overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url(https://tristatewarriors.com/wp-content/uploads/2025/03/UPSTATE-1-1.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <div className="inline-block bg-red-600 px-4 py-2 rounded-full text-sm font-bold mb-6">
              SEASON ANNOUNCEMENT
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight">
              We're Back for the New Season!
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Get ready, Warriors fans! The Tri-State Warriors are returning stronger and more determined than ever for the new season. With new talent, renewed energy, and the same unstoppable spirit, we're gearing up for an unforgettable series of games. Stay tuned for thrilling matchups, intense action, and the heart-pounding excitement you've come to love. Let's make this season our best yet!
            </p>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSf1_pmDnir9wO6A_cDHBPNg4ezmbiIf5P8ar6Qac2uzqy-TYw/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-red-600 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-red-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              JOIN US NOW!
            </a>
          </div>

          {/* Right Content - Countdown */}
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
            <h3 className="text-2xl font-bold text-white text-center mb-8">
              2025 SEASON STARTS IN
            </h3>
            <div className="grid grid-cols-4 gap-4">
              <div className="text-center">
                <div className="bg-red-600 rounded-xl p-4 mb-2">
                  <div className="text-4xl font-black text-white">
                    {String(timeLeft.days).padStart(3, '0')}
                  </div>
                </div>
                <div className="text-sm font-semibold text-white">DAYS</div>
              </div>
              <div className="text-center">
                <div className="bg-red-600 rounded-xl p-4 mb-2">
                  <div className="text-4xl font-black text-white">
                    {String(timeLeft.hours).padStart(2, '0')}
                  </div>
                </div>
                <div className="text-sm font-semibold text-white">HOURS</div>
              </div>
              <div className="text-center">
                <div className="bg-red-600 rounded-xl p-4 mb-2">
                  <div className="text-4xl font-black text-white">
                    {String(timeLeft.minutes).padStart(2, '0')}
                  </div>
                </div>
                <div className="text-sm font-semibold text-white">MINUTES</div>
              </div>
              <div className="text-center">
                <div className="bg-red-600 rounded-xl p-4 mb-2">
                  <div className="text-4xl font-black text-white">
                    {String(timeLeft.seconds).padStart(2, '0')}
                  </div>
                </div>
                <div className="text-sm font-semibold text-white">SECONDS</div>
              </div>
            </div>
            <div className="mt-8 text-center">
              <img
                src="https://tristatewarriors.com/wp-content/uploads/2024/03/Tri-State-Warriors-Sponsorship-GLADIATOR.png"
                alt="Gladiator Sponsorship"
                className="w-full max-w-md mx-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
